import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { BulkDeleteOverrideRulesRequestDto } from '../../../api/dto/plan-benefit-override-rules.dto'
import { bulkDeleteOverrideRules } from '../../../api/plan-benefit-override-rules-api'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

export function useBulkDeleteOverrideRules() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: BulkDeleteOverrideRulesRequestDto) =>
      bulkDeleteOverrideRules(body),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
